(() => {
    tinymce.PluginManager.add('chadsan_theme_typedtext_button', (editor, url) => {
        editor.addButton( 'chadsan_theme_typedtext_button', {
            text: 'Typed Text',
            onclick: e => {
                const $selectedEl = editor.selection.getNode();
                let selectedText = '';

                console.log($selectedEl);

                if ( $selectedEl.dataset?.typedTextOptions ) {
                    selectedText = JSON.parse($selectedEl.dataset.typedTextOptions);
                    selectedText = selectedText.join("\n");
                } else {
                    selectedText = editor.selection.getContent();
                }

                editor.windowManager.open( {
                    title: 'Typed Text',
                    icon: 'plus',
                    size: 'large',
                    body: [{
                        type: 'textbox',
                        name: 'typed-text',
                        label: 'Insert each item on a new line',
                        multiline: true,
                        value: selectedText,
                        minHeight: 60
                    }],
                    onsubmit: e => {
                        let typedTextArray = e.data['typed-text'];
                        
                        if ( typedTextArray ) {
                            typedTextArray = typedTextArray.split('\n');
                        }

                        if ( typedTextArray && typedTextArray?.length ) {
                            if ( $selectedEl.dataset?.typedTextOptions ) {
                                $selectedEl.dataset.typedTextOptions = JSON.stringify(typedTextArray);
                                $selectedEl.innerHTML = typedTextArray[0];
                            } else {
                                editor.insertContent(`<span class="typed-text" data-typed-text-options='${JSON.stringify(typedTextArray)}'>${typedTextArray[0]}</span>`);
                            }
                        } else if ( $selectedEl ) {
                            const selectedElText = $selectedEl.innerHTML;
                            $selectedEl.remove();
                            editor.insertContent(selectedElText);
                        }
                    }
                });
            }
        });
    });
})();
